<template>
    <div id="home">
        <HomeVideo />
        <Sponsors :showFirstHalf="true" style="background: #f7f7f7" :homepagePadding="true"/>
        <MoreBlock 
            :title="content.title"
            :content="content.details"
            linkURL='/about'
        />
        <ContentBlock
            class="content-block"
            :title="content1.title"
            :content="content1.content"
            :linkURL="content1.linkURL"
            :linkLabel="content1.linkLabel"
            :img="content1.img"
            :homepage="true"
            :border="false"
        />
        <Testimonial :slides="testimonials" />
        <!-- <div class="container service-container desktop" >
            <SectionTitle title="Core Services" class="top-margin"/>
            <Services />
        </div> -->
        <!-- <div class="container service-container">
            <SectionTitle title="Project Gallery"/>
        </div> -->
        <HomepageSlideshow
            v-if="slides.length > 0"
            :data="slides"
            />   
        <div v-else>
            <Spinner size="large" message="Loading..." line-fg-color="#000" style="padding: 5rem 0;"/>
        </div>
        <div class="btn_container">
            <router-link to="/work" class="btn">
                More Projects
            </router-link>
        </div>
    </div>
</template>

<script>
import HomeVideo from '../components/HomeVideo'
import Sponsors from '../components/Sponsors';
import MoreBlock from '../components/MoreBlock';
import ContentBlock from '../components/ContentBlock';
import Testimonial from '../components/Testimonial';
//import SectionTitle from '../components/SectionTitle';
import HomepageSlideshow from '../components/HomepageSlideshow';
//import Services from '../components/Services'
import Spinner from 'vue-simple-spinner'

export default {
    name: "Home",
    components: {
        HomeVideo,
        Sponsors,
        MoreBlock,
        ContentBlock,
        Testimonial,
        HomepageSlideshow,
        Spinner
    },
    metaInfo: {
        title: 'Uptown Creative | Marketing for Luxury Real Estate',
        meta: [{
            name: 'description', 
            content: "Trusted by Top Producing Agents & Leading Brands Nationwide"
        }]
    },
    mounted:function(){
        this.axios.get('https://api.uptowncreative.io/_/items/uptowncreative?fields=company_name,featured,subtitle,short_description,slideshow_order,show_video_homepage_slideshow,video_section_url,show_case_image.*&filter[status][eq]=published&filter[featured][nempty]&sort=slideshow_order')
        .then((response) => {
            this.slides = response.data.data
            /*
            this.slides.sort(function (a, b) {
                return a.order - b.order;
            });
            */
        })
    },
    data(){
        return{
            slides : [],
            testimonials: [
                {
                    author: 'Chad Rogers',
                    content: '"Austin has handled my real estate website for 9 years. I highly recommend him and his company."',
                }
            ],
            content:{
                title: "Trusted by Top Producing Agents <br>& Leading Brands Nationwide",
                details: "Our clients range from startups<br> to Fortune 500 companies."

            },
            content1:{
                title: 'Holistic Digital Marketing',
                content: 'High-profile real estate agent and TV personality Chad Rogers partners with Uptown Creative to fortify his brand and engage his audience.',
                linkURL: '/case/chad-rogers',
                linkLabel: 'View Case Study',
                img: '/images/uptowncreative-homepage.jpg'
            },
        }
    },
}   
</script>

<style lang="scss" scoped>
.home-title{
    padding: 2rem 0;
}
.first-block{
    margin-top: 1rem;
}
.service-container{
    margin-top: 4rem;
}
.content-block{
    margin: 0;
    padding: 103px 0;
}
.btn_container{
    text-align: center;
    margin: 47px 0 77px;
}
.btn{
    display: inline-block;
    margin: 0.5rem auto;
    color: #000;
    font-size: 16px;
    letter-spacing: 1.5px;
    padding: 14px 24px;
    border: solid 1px #727272;
    font-weight: 500;
}

@media (max-width: $mobile) { 
    .home-title{
        padding: 2rem 0;
        padding-bottom: 0;
    }
    .content-block{
        margin: 0;
        padding: 77px 0;
    }
    .service-container{
        margin-top: 77px;
    }

}

</style>